// extracted by mini-css-extract-plugin
module.exports = {"footer":"MapModal_footer__2UEOp","btnSet":"MapModal_btnSet__2I8-1"};